import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const CancellationIcon = ({ type, theme, title }) => (
  <Icon>
    <svg
      id="blue_svg_2px"
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      title={title}
      type={type}
      viewBox="0 0 140 140"
    >
      <title>cancellation_1_blue_circle</title>
      <g id="cercle" fill={theme.primaryColor}>
        <path d="M70,140a70,70,0,1,1,70-70A70.08,70.08,0,0,1,70,140ZM70,2a68,68,0,1,0,68,68A68.08,68.08,0,0,0,70,2Z" />
      </g>
      <g fill={theme.primaryColor}>
        <path d="M36.06,109.4h67.77a5.2,5.2,0,0,0,5.24-5.15V44.87a5.31,5.31,0,0,0-5.32-5.15H96.21a1,1,0,0,0-1,1v4.66c0,4.79-2.37,7.22-7,7.22s-7-2.43-7-7.22V40.71a1,1,0,0,0-1-1H58.94a1,1,0,0,0-1,1v4.66c0,3.57-.84,7.22-7,7.22s-7-3.65-7-7.22V40.71a1,1,0,0,0-1-1H36.06a5.2,5.2,0,0,0-5.24,5.15v59.38A5.2,5.2,0,0,0,36.06,109.4ZM32.83,44.87a3.16,3.16,0,0,1,3.24-3.15h5.78v3.66c0,2.28,0,9.22,9,9.22,6,0,9-3.1,9-9.22V41.71H79.11v3.66c0,5.94,3.21,9.22,9,9.22s9-3.36,9-9.22V41.71h6.54a3.32,3.32,0,0,1,3.32,3.15v59.38a3.16,3.16,0,0,1-3.24,3.15H36.06a3.16,3.16,0,0,1-3.24-3.15Z" />
        <path d="M50.89,50.19a4.82,4.82,0,0,0,4.81-4.81V35.21a4.81,4.81,0,1,0-9.62,0V45.37A4.82,4.82,0,0,0,50.89,50.19Zm-2.81-15a2.81,2.81,0,1,1,5.62,0V45.37a2.81,2.81,0,1,1-5.62,0Z" />
        <path d="M88.16,50.19A4.82,4.82,0,0,0,93,45.37V35.21a4.81,4.81,0,0,0-9.62,0V45.37A4.82,4.82,0,0,0,88.16,50.19Zm-2.81-15a2.81,2.81,0,0,1,5.62,0V45.37a2.81,2.81,0,0,1-5.62,0Z" />
        <path d="M40.3,102.7h6.27a6.72,6.72,0,0,0,10.32,1l1-1,.12,0H81.66a1,1,0,0,0,.29-.06L83,103.7a6.71,6.71,0,0,0,10.32-1H99.6a2.62,2.62,0,0,0,2.69-2.61V61a2.69,2.69,0,0,0-2.69-2.61H92.25a6.72,6.72,0,0,0-9,0H56.64a6.69,6.69,0,0,0-9,0l-.12,0H40.3A2.62,2.62,0,0,0,37.61,61V100.1A2.69,2.69,0,0,0,40.3,102.7Zm19.59-2,9.06-9.06V97a1,1,0,0,0,2,0V91.65L80,100.7ZM100.29,61V100.1a.64.64,0,0,1-.69.61H94.23a6.72,6.72,0,0,0-1.73-6.51L89.34,91h7.4a1,1,0,0,0,0-2H88.86V82.44l7.87.13h0a1,1,0,0,0,0-2l-7.9-.13V73.25h7.89a1,1,0,0,0,0-2h-7.4l3.16-3.16a6.73,6.73,0,0,0,1.26-7.74H99.6A.69.69,0,0,1,100.29,61ZM80.62,82.3l6.24.1v6.14Zm6.24-1.9L80.3,80.3l6.57-6.57ZM70.95,70.63V64.2a1,1,0,0,0-2,0v6.43L58.67,60.35H81.23Zm-18.8-12A4.69,4.69,0,0,1,55.48,60L69.24,73.75a1,1,0,0,0,1.41,0L84.41,60a4.72,4.72,0,0,1,6.68,6.68L77.33,80.43a1,1,0,0,0,0,1.41l9.74,9.74a1,1,0,0,0,.2.2l3.82,3.82a4.72,4.72,0,0,1-6.68,6.68L70.66,88.53a1,1,0,0,0-1.41,0L55.48,102.28A4.72,4.72,0,1,1,48.8,95.6L62.56,81.85a1,1,0,0,0,0-1.41L48.8,66.67a4.72,4.72,0,0,1,3.34-8.06Zm.55,14.78,6.89,6.89H52.69Zm6.61,8.89-6.61,6.61V82.28ZM39.61,61a.64.64,0,0,1,.69-.61h5.83a6.73,6.73,0,0,0,1.26,7.74l2.74,2.74H42.8a1,1,0,0,0,0,2h7.89v7.45H42.8a1,1,0,0,0,0,2h7.89v7.17H42.8a1,1,0,0,0,0,2h7.32l-2.74,2.74a6.72,6.72,0,0,0-1.73,6.51H40.3a.69.69,0,0,1-.69-.61Z" />
      </g>
    </svg>
  </Icon>
);

CancellationIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

CancellationIcon.defaultProps = {
  title: "Cancellation Icon",
  type: "secondary"
};

export default withTheme(CancellationIcon);
